import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game3Store')
@observer
export default class Game3Step2 extends Component {

    chooseNumber(number) {
        this.props.Game3Store.setPlayers(number);
    }

    render() {

        const {
            players
        } = this.props.Game3Store;

        const numberPlayers = players.length;

        return (
            <div className="step-2">
                <h1>Number Of Teams</h1>
                <div className="buttons">
                    <button
                        className={numberPlayers === 2 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 2)}>2</button>
                    <button
                        className={numberPlayers === 3 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 3)}>3</button>
                </div>
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step2.js